function normalizeFieldName(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

function readRowProperty(row, property) {
  if (!row || typeof row !== "object") {
    return undefined;
  }

  if (row[property] !== undefined) {
    return row[property];
  }

  const normalizedProperty =
    normalizeFieldName(property);
  const matchingKey = Object.keys(row).find(
    (key) =>
      normalizeFieldName(key) ===
      normalizedProperty
  );

  return matchingKey
    ? row[matchingKey]
    : undefined;
}

function getRowFieldValue(row, fields) {
  for (const field of fields) {
    const directValue =
      readRowProperty(row, field);

    if (
      directValue !== null &&
      directValue !== undefined &&
      String(directValue).trim()
    ) {
      return directValue;
    }
  }

  const rowField = [
    readRowProperty(row, "field"),
    readRowProperty(row, "key"),
    readRowProperty(row, "metric"),
    readRowProperty(row, "name"),
  ].find(
    (value) =>
      value !== null &&
      value !== undefined &&
      String(value).trim()
  );

  if (!rowField) {
    return null;
  }

  const normalizedFields =
    fields.map(normalizeFieldName);

  return normalizedFields.includes(
    normalizeFieldName(rowField)
  )
    ? readRowProperty(row, "value")
    : null;
}

export function firstNumeric(rows, fields, { allowZero = false, max = Infinity } = {}) {
  for (const row of rows || []) {
    const rawValue = getRowFieldValue(row, fields);
    if (rawValue == null || typeof rawValue === "boolean" || String(rawValue).trim() === "") continue;
    const value = Number(rawValue);

    if (
      Number.isFinite(value) &&
      (allowZero ? value >= 0 : value > 0) &&
      value <= max
    ) {
      return value;
    }
  }

  return null;
}

export function firstText(rows, fields) {
  for (const row of rows || []) {
    const value =
      getRowFieldValue(row, fields);

    if (
      value !== null &&
      value !== undefined &&
      String(value).trim()
    ) {
      return String(value).trim();
    }
  }

  return null;
}

export function getRepairQuota(rows, year) {
  const yearRows = (Array.isArray(rows) ? rows : []).filter(
    row => row?.year != null && String(row.year) === String(year)
  );
  return firstNumeric(yearRows, [
    "repair_quota_pct",
    "reparaturquote_pct",
    "repairQuotePct",
    "repair_quote_pct",
  ], { allowZero: true, max: 100 });
}
